import { IAdvancedSearchConfiguration } from '../components/case-search/advanced-search-configuration.interface';
import { IgenomicsAction } from '../../core/interfaces/genomics-action.interface';
import { SetAdvancedSearchConfiguration } from './advanced-search.actions';

export interface AdvancedSearchState {
  configuration?: IAdvancedSearchConfiguration;
}

export function advancedSearchReducer(state: AdvancedSearchState  = { }, action: IgenomicsAction): AdvancedSearchState {
  switch (action.type) {
    case SetAdvancedSearchConfiguration:
      return { ...state, configuration: action.payload};
    default:
      return state;
  }
}
